"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScrollPosition = void 0;

var react_1 = require("react");

var useIsomorphicLayoutEffect_1 = require("./useIsomorphicLayoutEffect");

var isBrowser = typeof window !== "undefined";
var zeroPosition = {
  x: 0,
  y: 0
};

var getClientRect = function getClientRect(element) {
  return element === null || element === void 0 ? void 0 : element.getBoundingClientRect();
};

var getScrollPosition = function getScrollPosition(_ref) {
  var element = _ref.element,
      useWindow = _ref.useWindow,
      boundingElement = _ref.boundingElement;

  if (!isBrowser) {
    return zeroPosition;
  }

  if (useWindow) {
    return {
      x: window.scrollX,
      y: window.scrollY
    };
  }

  var targetPosition = getClientRect((element === null || element === void 0 ? void 0 : element.current) || document.body);
  var containerPosition = getClientRect(boundingElement === null || boundingElement === void 0 ? void 0 : boundingElement.current);

  if (!targetPosition) {
    return zeroPosition;
  }

  return containerPosition ? {
    x: (containerPosition.x || 0) - (targetPosition.x || 0),
    y: (containerPosition.y || 0) - (targetPosition.y || 0)
  } : {
    x: targetPosition.left,
    y: targetPosition.top
  };
};

exports.useScrollPosition = function (effect, deps, element, useWindow, wait, boundingElement) {
  var position = react_1.useRef(getScrollPosition({
    useWindow: useWindow,
    boundingElement: boundingElement
  }));
  var throttleTimeout = null;

  var callBack = function callBack() {
    var currPos = getScrollPosition({
      element: element,
      useWindow: useWindow,
      boundingElement: boundingElement
    });
    effect({
      prevPos: position.current,
      currPos: currPos
    });
    position.current = currPos;
    throttleTimeout = null;
  };

  useIsomorphicLayoutEffect_1.useIsomorphicLayoutEffect(function () {
    var _a;

    if (!isBrowser) {
      return undefined;
    }

    var handleScroll = function handleScroll() {
      if (wait) {
        if (throttleTimeout === null) {
          throttleTimeout = setTimeout(callBack, wait);
        }
      } else {
        callBack();
      }
    };

    if (boundingElement) {
      (_a = boundingElement.current) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', handleScroll);
    } else {
      window.addEventListener('scroll', handleScroll);
    }

    return function () {
      var _a;

      if (boundingElement) {
        (_a = boundingElement.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', handleScroll);
      } else {
        window.removeEventListener('scroll', handleScroll);
      }

      if (throttleTimeout) {
        clearTimeout(throttleTimeout);
      }
    };
  }, deps);
};

exports.useScrollPosition.defaultProps = {
  deps: [],
  element: false,
  useWindow: false,
  wait: null,
  boundingElement: false
};